import type { FC } from "react";
import { cn } from "utils";

interface OnboardingBubbleTailProps {
  variant?: "dark" | "light";
  className?: string;
}

/** Figma bubble tail (96121:8435 tail @ left -7px, top ~18px). */
export const OnboardingBubbleTail: FC<OnboardingBubbleTailProps> = ({
  variant = "dark",
  className,
}) => (
  <span
    aria-hidden
    data-testid="ed-hero-bubble-tail"
    className={cn(
      "absolute -left-[7px] top-[18px] size-0 border-y-[6px] border-y-transparent border-r-[7px]",
      variant === "dark"
        ? "border-r-content_secondary"
        : "border-r-background_brand_overlay10",
      className,
    )}
  />
);
